import React from "react";
import { CopyButton } from "../shared";

const SKILL_URL = "https://dev.horuswallet.com/skill.md";

export default function SkillInstructions() {
  const claudeMdSnippet = `For Horus Wallet MCP tools, follow: ${SKILL_URL}`;
  const desktopSnippet = `Follow the Horus Wallet skill at ${SKILL_URL} for all wallet, crypto, and payment operations.`;
  const directPrompt = `Fetch ${SKILL_URL} and use those instructions for all Horus wallet operations`;

  return (
    <div className="mcp-skill-instructions">
      <h5 className="mcp-subsection-title">Step 2: Add the skill (recommended)</h5>
      <p className="mcp-step-desc">
        Adding the skill teaches your AI agent how to use the Horus tools
        automatically — which tool to call, what parameters to use, and best
        practices.
      </p>

      <div className="mcp-skill-method">
        <h6 className="mcp-method-title">For Claude Code:</h6>
        <p>
          Add to your <code className="mcp-inline-code">CLAUDE.md</code>:
        </p>
        <pre className="mcp-code-block">{claudeMdSnippet}</pre>
        <CopyButton text={claudeMdSnippet} label="Copy" />
      </div>

      <div className="mcp-skill-method">
        <h6 className="mcp-method-title">For Claude Desktop:</h6>
        <p>
          Add to <code className="mcp-inline-code">systemPrompt</code> in{" "}
          <code className="mcp-inline-code">claude_desktop_config.json</code>:
        </p>
        <pre className="mcp-code-block">{desktopSnippet}</pre>
        <CopyButton text={desktopSnippet} label="Copy" />
      </div>

      <div className="mcp-skill-method">
        <h6 className="mcp-method-title">Or tell your agent directly:</h6>
        <pre className="mcp-code-block">{directPrompt}</pre>
        <CopyButton text={directPrompt} label="Copy" />
      </div>
    </div>
  );
}
